<template>
  <div class="certificaiton_table_list">
    <tab />
    <div class="body_content" v-if="info">
      <el-row v-if="info.role ==='UserRoleEmployee' || info.role ==='UserRoleEnterprise'">
        <el-col :span="12">
          <el-button @click="go('enterprise_evacuate_form')">添加申请</el-button>
          <router-link
            class="process_text"
            to="/personal_center/enterprise/property_services/evacuate/process"
          >
            业务办理须知
            <i class="el-icon-d-arrow-right"></i>
          </router-link>
        </el-col>
        <el-col :span="12">
          <div style="text-align:right;">
            <el-input @change="search" placeholder="请输入单号" v-model="form.code" style="width:200px;"></el-input>
            <el-select
              v-model="form.status"
              placeholder="状态筛选"
              style="width:200px;margin-left:20px;"
              @change="search"
            >
              <el-option label="全部审批状态" value></el-option>
              <el-option label="待处理" value="10"></el-option>
              <el-option label="预审通过" value="60"></el-option>
              <el-option label="预审退回" value="30"></el-option>
              <el-option label="已完成" value="70"></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <!-- 企业身份 -->
      <div v-if="info.role ==='UserRoleEmployee' || info.role ==='UserRoleEnterprise'">
        <el-table :data="tableData" border style="width: 100%;margin-top:20px;">
          <el-table-column fixed prop="float_type_name" label="业务类型"></el-table-column>
          <el-table-column prop="contact" label="经办人"></el-table-column>
          <el-table-column prop="code" label="单号"></el-table-column>
          <el-table-column prop="apply_date" label="提交时间"></el-table-column>
          <el-table-column prop="status_name" label="状态" width="90"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <!-- 未提交|| 已撤回 -->
              <div class="center" v-if="scope.row.status===50 || scope.row.status=== 40">
                <div>
                  <div class="blue_btn" @click="backEdit(scope.row)">编辑</div>
                </div>
              </div>
              <!-- 已提交 -->
              <div class="center" v-else-if="scope.row.status===10">
                <div>
                  <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                </div>
                <div>
                  <div class="blue_btn" @click="withdrawAuthenticateDialog(scope.row)">撤回</div>
                </div>
              </div>
              <!-- 已退回 -->
              <div class="center" v-else-if="scope.row.status===30">
                <div>
                  <div class="blue_btn" @click="viewOpinions(scope.row)">退回原因</div>
                </div>
                <div>
                  <div class="blue_btn" @click="backEdit(scope.row)">编辑</div>
                </div>
              </div>
              <div v-else>
                 <div>
                  <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
        </div>
      </div>
      <!-- 普通身份 -->
      <div v-else-if="info.role ==='UserRoleOrdinary'">
        <el-button type="primary" @click="go('employee_certification');">认证为员工</el-button>
        <el-button type="primary" @click="go('enterprise_certification');">认证为企业</el-button>
      </div>
    </div>
    <!-- 意见 -->
    <el-dialog title="查看意见" :visible.sync="dialogVisible" width="600px" center>
      <span v-if="row && row.release_examine_remark" v-cloak>{{row.release_examine_remark}}</span>
      <span v-else>暂无</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myPage from "@/components/myPage/myPage";
import tab from "../../components/tab";
export default {
  components: {
    myPage,
    tab
  },
  data() {
    return {
      form: { status: "", code: "" },
      tableSwitch: 0, //模块展示判断 1:企业 2：普通 3：员工
      tableData: [],
      layerpageinfo: {
        pageNo: 0,
        total: 0,
        pageSize: 10
      },
      row: null, //临时操作行
      searchData: {},
      dialogVisible:false
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    parkInfo() {
      return this.$store.state.parkInfo;
    }
  },
  created() {
    if (this.parkInfo) {
      this.getList();
    } else {
      this.needInfo("parkInfo", "getList");
    }
  },
  methods: {
    /* 监测信息 */
    needInfo(name, fn) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[fn] && this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    search() {
      this.layerpageinfo = {
        pageNo: 0,
        total: 0,
        pageSize: 10
      };
      this.getList();
    },
    /** 列表*/
    getList() {
      let params = Object.assign({}, this.layerpageinfo, this.form, {
        types: 40,
        incubator: this.parkInfo.id
      });
      this.api.getApply(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.tableData = res.obj.list || [];
        this.layerpageinfo.total = res.obj.totalSize;
      });
    },
    /*页面跳转*/

    go(name) {
      this.$router.push({
        name: name
      });
    },
    /*改变分页*/

    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getFrontAuthenticates();
    },
    /*返回修改 编辑*/
    backEdit(item) {
      this.$router.push({
        name: "enterprise_evacuate_form",
        query: {
          id: item.id
        }
      });
    },
    /*查看详情*/

    detail(item) {
      this.$router.push({
        name: "enterprise_evacuate_detail",
        query: {
          id: item.id
        }
      });
    },
    /* 撤回机构认证弹窗*/
    withdrawAuthenticateDialog(row) {
      this.$confirm("确定撤回?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.withdrawAuthenticate(row);
        })
        .catch(() => {});
    },
    /* 撤回机构认证 */
    withdrawAuthenticate(row) {
      this.api
        .withdrawApply({
          id: row.id
        })
        .then(res => {
          if (res.error.err_code !== 0) return;
          this.$message({
            type: "success",
            message: "撤回成功!"
          });
          this.getList(); //列表
        });
    },
    /* 查看意见 */
    viewOpinions(row) {
      this.dialogVisible = true;
      this.row = row;
    }
  }
};
</script>

<style lang="scss" scoped>
.blue_btn {
  color: $font-blue;
  cursor: pointer;
}
.process_text {
  font-size: 14px;
  color: #4c84ff;
  margin-left: 10px;
}
</style>